import { CurrencyCode } from 'types/currency';

export const LABELS = {
  CREATE_MODAL: {
    TITLE: ['orderTableCell.layout.createAccountModal.title', 'Create New Account'],
    HEADER: {
      RAMP_TITLE: ['orderTableCell.layout.createAccountModal.header.rampTitle', 'Crypto Ramp'],
      PWC_TITLE: ['orderTableCell.layout.createAccountModal.header.pwcTitle', 'Pay with Crypto'],
    },
    PWC_OPTIONS: {
      MERCHANT: ['orderTableCell.layout.createAccountModal.pwcOptions.merchant', 'Merchant Account'],
      GROUP_ACCOUNT: ['orderTableCell.layout.createAccountModal.pwcOptions.ga', 'Group Account'],
    },
    PWC_CUSTOMER_OPTIONS: {
      INDIVIDUAL: ['orderTableCell.layout.createAccountModal.pwcCustomerOptions.individual', 'Individual Account'],
      BUSINESS: ['orderTableCell.layout.createAccountModal.pwcCustomerOptions.businesss', 'Business Account'],
    },
    BUTTONS: {
      CREATE: ['orderTableCell.layout.createAccountModal.buttons.create', 'Create Account'],
      CANCEL: ['orderTableCell.layout.createAccountModal.buttons.cancel', 'Cancel'],
      EDIT: ['orderTableCell.layout.createAccountModal.buttons.edit', 'Edit'],
      CONFIRM: ['orderTableCell.layout.createAccountModal.buttons.confirm', 'Confirm'],
      CLOSE: ['orderTableCell.layout.createAccountModal.buttons.close', 'Close'],
    },
    SECTIONS: {
      ACCOUNT_SECTION: {
        TITLE: ['orderTableCell.layout.createAccountModal.sections.accountSection.title', 'Account Name'],
      },
      GROUP_ACCOUNT_SECTION: {
        TITLE: ['orderTableCell.layout.createAccountModal.sections.groupAccountSection.title', 'Associated Group Account'],
      },
      PARENT_ACCOUNT_SECTION: {
        TITLE: ['orderTableCell.layout.createAccountModal.sections.parentAccountSection.title', 'Parent Account'],
      },
      FIAT_CURRENCY_SECTION: {
        TITLE: ['orderTableCell.layout.createAccountModal.sections.fiatCurrencySection.title', 'Fiat Payout Currency'],
      },
      MERCHANT_ID_SECTION: {
        TITLE: ['orderTableCell.layout.createAccountModal.sections.merchantSection.title', 'Shift4 Merchant ID'],
      },
      ACCOUNT_OWNER_SECTION: {
        TITLE: ['orderTableCell.layout.createAccountModal.sections.accountOwnerSection.title', 'Account Owner Information'],
      },
      WELCOME_EMAIL_SECTION: {
        TITLE: ['orderTableCell.layout.createAccountModal.sections.welcomeEmail.title', 'Send welcome email <0></0>to the owner'],
      },
    },
    FORM_FIELDS: {
      OPTIONAL: ['orderTableCell.layout.createAccountModal.form.optional', 'Optional'],
      PLACEHOLDERS: {
        ACCOUNT_NAME: ['orderTableCell.layout.createAccountModal.form.accountName.placeholder', 'Enter Account Name'],
        EMAIL: ['orderTableCell.layout.createAccountModal.form.email.placeholder', 'Email'],
        MERCHANT_ID: ['orderTableCell.layout.createAccountModal.form.merchant.placeholder', 'Enter Merchant ID'],
        GROUP_ACCOUNT_ID: ['orderTableCell.layout.createAccountModal.form.groupAccount.placeholder', 'Select Group Account'],
        PARENT_ACCOUNT_UUID: ['orderTableCell.layout.createAccountModal.form.parentAccount.placeholder', 'Select Parent Account'],
        FIRST_NAME: ['orderTableCell.layout.createAccountModal.form.firstName.placeholder', 'First Name'],
        LAST_NAME: ['orderTableCell.layout.createAccountModal.form.lastName.placeholder', 'Last Name'],
      },
    },
    VERIFY_STEP: {
      PRODUCT: {
        TITLE: ['orderTableCell.layout.createAccountModal.verifyStep.product.title', 'Product'],
        RAMP: ['orderTableCell.layout.createAccountModal.verifyStep.product.ramp', 'Crypto Ramp'],
        PWC: ['orderTableCell.layout.createAccountModal.verifyStep.product.pwc', 'Pay with Crypto'],
        GROUP_ACCOUNT: ['orderTableCell.layout.createAccountModal.verifyStep.product.ga', 'Pay with Crypto: Group'],
        PSP: ['orderTableCell.layout.createAccountModal.verifyStep.product.psp', 'Pay with Crypto: PSP'],
      },
      WELCOME_EMAIL: {
        LABEL: ['orderTableCell.layout.createAccountModal.verifyStep.welcomeEmail.label', 'Send welcome email'],
        YES: ['orderTableCell.layout.createAccountModal.verifyStep.welcomeEmail.yes', 'Yes'],
        NO: ['orderTableCell.layout.createAccountModal.verifyStep.welcomeEmail.no', 'No'],
      },
      PWC_CUSTOMER_TYPE: ['orderTableCell.layout.createAccountModal.verifyStep.pwcCustomerType', 'Customer Type'],
      TITLE: ['orderTableCell.layout.createAccountModal.verifyStep.title', "Please verify the account's information"],
      ACCOUNT_NAME_LABEL: ['orderTableCell.layout.createAccountModal.verifyStep.accountNameLabel', 'Account Name'],
      GROUP_ACCOUNT_ID_LABEL: ['orderTableCell.layout.createAccountModal.verifyStep.groupAccountIdLabel', 'Group Account ID'],
      PARENT_ACCOUNT_ID_LABEL: ['orderTableCell.layout.createAccountModal.verifyStep.parentAccountIdLabel', 'Parent Account'],
      MERCHANT_ID_LABEL: ['orderTableCell.layout.createAccountModal.verifyStep.merchantIdLabel', 'Shift4 Merchant ID'],
      ACCOUNT_OWNER_LABEL: ['orderTableCell.layout.createAccountModal.verifyStep.accountOwnerLabel', 'Account Owner Information'],
      NO_VALUE: ['orderTableCell.layout.createAccountModal.verifyStep.noValue', '-'],
      MAIN_FIAT_CURRENCY: ['orderTableCell.layout.createAccountModal.verifyStep.currencyLabel', 'Fiat Payout Currency'],
    },
    SUCCESS_STEP: {
      TITLE: ['orderTableCell.layout.createAccountModal.successStep.title', 'Success!'],
      CREATED_LABEL: ['orderTableCell.layout.createAccountModal.successStep.createdLabel', 'successfully created'],
    },
    CURRENCY_LABELS: {
      [CurrencyCode.BRL]: ['orderTableCell.layout.createAccountModal.currencyLabels.brl', 'Brazilian Real (BRL)'],
      [CurrencyCode.COP]: ['orderTableCell.layout.createAccountModal.currencyLabels.cop', 'Colombian Peso (COP)'],
      [CurrencyCode.EUR]: ['orderTableCell.layout.createAccountModal.currencyLabels.eur', 'Euro (EUR)'],
      [CurrencyCode.MXN]: ['orderTableCell.layout.createAccountModal.currencyLabels.mxn', 'Mexican Peso (MXN)'],
      [CurrencyCode.USD]: ['orderTableCell.layout.createAccountModal.currencyLabels.usd', 'US Dollar (USD)'],
    },
  },
};

const FORM_FIELDS = {
  ACCOUNT_NAME: 'accountName',
  MERCHANT_ID: 'shift4MerchantId',
  GROUP_ACCOUNT_ID: 'groupAccountId',
  PARENT_ACCOUNT_UUID: 'parentAccountUuid',
  EMAIL: 'username',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  MAIN_FIAT_CURRENCY: 'mainFiatCurrency',
};

export const KEYS: { FORM_FIELDS: typeof FORM_FIELDS; OPTIONAL: string[] } = {
  FORM_FIELDS,
  OPTIONAL: [FORM_FIELDS.MERCHANT_ID],
};
